var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-call-to-action',{staticClass:"no-mobile",attrs:{"dark":"","outline":"","cssClass":"botao-participar"},on:{"click":_vm.processarReenvioDocumentos}},[_vm._v(" Enviar Documentos ")])}
var staticRenderFns = []

export { render, staticRenderFns }